export const PROJECT_TITLE = "activation.home.projects.title";
export const VIEW_ALL_BUTTON = "activation.home.projects.view.all";
export const CREATE_PROJECT = "project.creation.modal.button.create";
export const COMPETITORS_TEXT = "activation.home.projects.competitors.text";
